
export const StandardMapScale = ({coverageAcceptance, setCoverageAcceptance}) => {

  const sections = ["#FF0000", "#FF8A00", "#FFF500", "#9EFF00", "#61FF00", "#00FF47", "#00FF94", "#00ffbb", "#00ffd0", "#00ffe5", "#2291E1"]

    return (
        <div className="map__scale--line">
          <div style={{position: 'absolute', top: 'calc(100% + 1rem)', left: '-1rem'}} className="ai-body-tiny ai-grey-100">Low</div>
          <div style={{position: 'absolute', top: 'calc(100% + 1rem)', left: 'calc(50% - 2rem)'}} className="ai-body-tiny ai-grey-100">Medium</div>
          <div style={{position: 'absolute', bottom: 'calc(100% + 1rem)', left: '3rem'}} className="ai-body-tiny ai-grey-100">Accepted Coverage Level</div>
          <div style={{position: 'absolute', top: 'calc(100% + 1rem)', right: '-1rem'}} className="ai-body-tiny ai-grey-100">High</div>
          {sections.map((s,index) => {

            return(
              <div style={{borderColor: s, backgroundColor: coverageAcceptance === Math.round((index*0.2) * 10) / 10 ? s : '#FFFFFF', left: `${(Math.round((index*2) * 10) / 10)-1}rem`}} key={index} onClick={() => setCoverageAcceptance(Math.round((index*0.2) * 10) / 10)}></div>

            )
          })}
  
        </div>
    

          
    );
};